import { agentsModule } from '@/modules/agents'
import { assetsModule } from '@/modules/assets'
import { assistantModule } from '@/modules/assistant'
import { auditModule } from '@/modules/audit'
import { billingModule } from '@/modules/billing'
import { canvasModule } from '@/modules/canvas'
import { classificationCatalogsModule } from '@/modules/classification-catalogs'
import { contentModule } from '@/modules/content'
import { eautomateModule } from '@/modules/eautomate'
import { hierarchyModule } from '@/modules/hierarchy'
import { iamModule } from '@/modules/iam'
import { identityModule } from '@/modules/identity'
import { integrationsModule } from '@/modules/integrations'
import { invitationsModule } from '@/modules/invitations'
import { notificationsModule } from '@/modules/notifications'
import { packagesModule } from '@/modules/packages'
import { reportingModule } from '@/modules/reporting'
import { styleGuideModule } from '@/modules/style-guide'
import { workflowsModule } from '@/modules/workflows'

export function listPlatformModules() {
  return [
    agentsModule,
    assetsModule,
    assistantModule,
    auditModule,
    billingModule,
    canvasModule,
    classificationCatalogsModule,
    contentModule,
    eautomateModule,
    hierarchyModule,
    iamModule,
    identityModule,
    integrationsModule,
    invitationsModule,
    notificationsModule,
    packagesModule,
    reportingModule,
    styleGuideModule,
    workflowsModule,
  ] as const
}
